export type OpenRenewalInvoiceInfo = {
  storefrontId?: string | null;
  paymentRequestId?: string | null;
  invoiceNumber?: string | null;
  amount: number;
  currency: string;
  dueDate?: string | null;
};

/** A fixed renewal day in `year` as UTC midnight (Feb 29 clamps to Feb 28). */
export const fixedRenewalDay = (year: number, month: number, day: number) => {
  const lastDay = new Date(Date.UTC(year, month, 0)).getUTCDate();
  return new Date(Date.UTC(year, month - 1, Math.min(day, lastDay)));
};

/** The renewal day a stored date stands for (a day-before value rounds up). */
export const renewalDayOnOrAfter = (date: Date, month: number, day: number) => {
  const sameYear = fixedRenewalDay(date.getUTCFullYear(), month, day);
  const storedDay = Date.UTC(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
  );
  return sameYear.getTime() < storedDay
    ? fixedRenewalDay(date.getUTCFullYear() + 1, month, day)
    : sameYear;
};

export const invoiceHref = (
  organizationId: string,
  invoice: OpenRenewalInvoiceInfo,
) =>
  invoice.storefrontId && invoice.paymentRequestId
    ? `/app/organization/${organizationId}/storefront/${invoice.storefrontId}/invoice/${invoice.paymentRequestId}`
    : null;

export const formatInvoiceAmount = (invoice: OpenRenewalInvoiceInfo) =>
  new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: invoice.currency.toUpperCase(),
  }).format(invoice.amount / 100);
